import { CrudFilter } from 'admin';
import { Dayjs, dayjs } from 'date';

import { DEFAULT_DAYS } from './constants';

export const formatFilterDate = (date: Dayjs) => date.toISOString();
export const createFromFilter = (date: Dayjs, fieldName: string): CrudFilter => ({
  field: fieldName,
  operator: 'gte',
  value: formatFilterDate(date),
});
export const createToFilter = (date: Dayjs, fieldName: string): CrudFilter => ({
  field: fieldName,
  operator: 'lte',
  value: formatFilterDate(date),
});

export const initialFromFilter = (fieldName: string): CrudFilter => createFromFilter(dayjs(), fieldName);

export const initialToFilter = (fieldName: string): CrudFilter => createToFilter(DEFAULT_DAYS, fieldName);
